import React from 'react'

import { CONFIG } from 'config'
import { useInstalledTrackingUserUuuid } from 'features/installed-software/InstalledSoftwareTracker'
import { useAppVersion } from 'features/app/hooks'

// eslint-disable-next-line import/no-unresolved
import LogoSvg from './logo-presync.svg?react'

type Props = {
  className?: string
}

export const Logo = React.memo((props: Props) => {
  const trackingUserId = useInstalledTrackingUserUuuid()

  const version = useAppVersion()

  const handleClick = (e: any) => {
    if (e.detail === 5) {
      const lines = [`v${version}`, `Deployment Time: ${CONFIG.DEPLOYMENT_TIME}`, `Tracking User ID: ${trackingUserId}`]
      alert(lines.join('\n\n'))
    }
  }

  return <LogoSvg className={props.className} onClick={handleClick} />
})
